import Main from '@script/components/Main'
import DefaultRouter from '@script/router/DefaultRouter'

/**
 * Application scripts
 */
const checkReadyState = () => {
    const to = document.querySelector('.application')

    if (document.readyState === 'complete' && to instanceof HTMLElement) {
        window.router = new DefaultRouter()
        window.router.init()

        window.application = new Main(to)
        window.application.init()
    }
}

/**
 * Reset page scroll
 */
if (window.history && 'scrollRestoration' in window.history) {
    history.scrollRestoration = 'manual'
} else {
    window.scrollTo(0, 0)
}

/**
 * Hot reload
 * Accept update
 */
if (module.hot) {
    module.hot.accept()

    if (window.application) {
        console.info('%c-- %s --', 'color: green; font-weight: bold;', 'RELOADING LOCATION')
        window.location.reload()
    }
}

/**
 * Add document state event listener
 */
document.addEventListener('readystatechange', checkReadyState)

/**
 * Check state on start
 */
checkReadyState()

